import { render, staticRenderFns } from "./TableAiWizard.vue?vue&type=template&id=37501428&scoped=true"
import script from "./TableAiWizard.vue?vue&type=script&lang=js"
export * from "./TableAiWizard.vue?vue&type=script&lang=js"
import style0 from "./TableAiWizard.vue?vue&type=style&index=0&id=37501428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37501428",
  null
  
)

export default component.exports